import { Library } from './Library';

/**
 * Paths — GEN-59, the second of the four library screens.
 *
 * A thin binding, for the reason `Courses` gives: what differs between the kinds is the
 * kind, the heading and where a row goes, and inventing a second list component is how
 * the two start disagreeing about what a filter does.
 *
 * New arrived with GEN-39. Until then the button was deliberately absent, because one
 * landing on NotFound reads as a broken feature rather than an absent one.
 */
export function Paths() {
  return (
    <Library
      kind="PATH"
      title="Paths"
      detailPath={(id) => `/library/paths/${id}`}
      newPath="new"
      narrows={['module']}
    />
  );
}
